import http from "../../api/axios";
import { IPagination } from "../../model/pagination";

class ClientService {
  getData = (params: IPagination): Promise<any> =>
    http.get("/customer", { params });

  createClient = (data: any): Promise<any> => http.post("/customer/", data);

  updateClient = (data: any, id: number): Promise<any> =>
    http.put(`/customer/${id}`, data);

  deleteClient = (id: number): Promise<any> => http.delete(`/customer/${id}`);
}

export default ClientService;
